import { useEffect, useState } from 'react';

import downIcon from 'static/img/icons/down-icon.svg';
import Dropdown from 'core/dropdown';
import fontStyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/CoverageDescription.module.scss';
import Text from 'core/text';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import { useTranslations } from 'next-intl';

const CoverageDescription = ({ item, isOpen = false }) => {
    const t = useTranslations('what-is-included');
    const itemList = item.list_item.split('-');
    const [isFullSize, setFullSize] = useState(false);
    const [open, setOpen] = useState(isOpen);

    useCustomMediaQuery(992, (e) => {
        setFullSize(e.matches);
    });

    useEffect(() => {
        setFullSize(window.innerWidth > 992);
    }, []);

    if (item.title === ' ') {
        return null;
    }

    // Split rows into groups of 5
    function splitItemList (itemList) {
        const rows = [];

        for (let i = 0; i < itemList.length; i += 5) {
            const rowItems = itemList.slice(i, i + 5);
            const row = (
                <div key={i}>
                    {rowItems.map((displayItem, index) => (
                        <p key={index}>
                            <span>✓</span> {displayItem}
                        </p>
                    ))}
                </div>
            );
            rows.push(row);
        }

        return rows;
    }

    return (
        <div className={styles.coverage_container}>
            <div
                onClick={() => setOpen(!open)}
                className={styles.title_container}
            >
                <div className={styles.icon}>
                    <Image
                        src={downIcon}
                        width={20}
                        style={{
                            transform: `rotate(${open ? 180 : 0}deg)`,
                            transition: 'all 0.3s ease-in'
                        }}
                        alt={t('alt-image')}
                    />
                </div>
                <p
                    className={
                        isFullSize ? fontStyles.text_header3_bold : fontStyles.text_header4
                    }
                >
                    {item.title}
                </p>
            </div>
            <Dropdown open={open}>
                <Text content={item.sentence1} />
                {isFullSize && (
                    <div className={styles.container}>
                        <div>
                            {splitItemList(itemList.slice(0, itemList.length / 2))}
                        </div>
                        <Spacer />
                        <div>
                            {splitItemList(itemList.slice(itemList.length / 2, itemList.length))}
                        </div>
                    </div>
                )}
                {!isFullSize && (
                    <div className={styles.container}>
                        {itemList.map((displayItem, index) => {
                            return (
                                <p key={index}>
                                    <span>✓</span> {displayItem}
                                </p>
                            );
                        })}
                    </div>
                )}
            </Dropdown>
        </div>
    );
};

CoverageDescription.propTypes = {
    item: PropTypes.object.isRequired,
    isOpen: PropTypes.bool
};

export default CoverageDescription;
